export enum AddToGroupStepType {
  DOCUMENTS = 'Documents',
  GROUP = 'Group',
  STRUCTURE = 'Structure',
}
